import validate from 'validate.js';
import isArray from 'lodash/isArray';
import constraints from './constraints';

/**
 * @param1 - (Required) Example: firstName, lastName, email, birthday.
 * Usage - matches the key in constraints
 * @param2 - (Required) Example: value of firstName, value of lastName, value of email, value of birthday.
 * Usage - checks the value against rules declared in constraints
 * @param3 - (Optional)
 * Usage - Return true or false.
 * @param4 - (Optional)
 * Usage - Custom error messages related to text.
 * @param5 - (Optional)
 * Usage - Custom error messages related to length of error text
 */
const parseValidation = (key, value, errorText, lengthErrorText) => {
    const buildAttribute = {
        [key]: value,
    };
    const buildErrorMessage = {
        errorText,
        lengthErrorText,
    };
    const handleValidation = validate(buildAttribute, constraints, buildErrorMessage);
    const errorMessage = handleValidation[key];
    return isArray(errorMessage) && errorMessage;
};

export default parseValidation;
